module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      panel_active: _vm.open
    }
  }, [_c('div', {
    staticClass: "brand-strengths__button-wrapper"
  }, [_c('button', {
    staticClass: "brand-strengths__button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._t("heading"), _vm._v(" "), _c('div', {
    staticClass: "brand_strengths_toggle-container"
  }, [_vm._t("toggle_symbol")], 2)], 2), _vm._v(" "), _c('p', {
    staticClass: "brand-strengths__item-copy",
    domProps: {
      "innerHTML": _vm._s(_vm.spliceContent(_vm.content))
    }
  }), _vm._v(" "), _c('transition-panel', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }]
  }, [_c('div', {
    staticClass: "brand-strengths__item-copy",
    domProps: {
      "innerHTML": _vm._s(_vm.joinContent(_vm.content))
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "brand-strengths__horizontal-rule"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-117b108f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BasePanel.vue
// module id = 258
// module chunks = 1